module.exports = __webpack_public_path__ + "img/image_6.553b64c4.svg";